import { useDioxus } from '@/lib/wasm'

export function LoadingDocument() {
  const ref = useDioxus('mount_loading_document')
  return <div ref={ref} className="contents" />
}

export function LoadingDocumentEditHeader() {
  const ref = useDioxus('mount_loading_document_edit_header')
  return <div ref={ref} className="contents" />
}

export function LoadingDocumentEditContent() {
  const ref = useDioxus('mount_loading_document_edit_content')
  return <div ref={ref} className="contents" />
}
